'use client';

import useInheritParams from '@/hooks/useInheritParams';
import { Link } from '@/ui-components/atoms/Link/Link';
import { forwardRef, Ref, useSyncExternalStore } from 'react';
import { URL_INHERIT_PARAMS } from '@/constants';

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    inheritParams?: boolean;
    dataCy?: string;
}

const SXMLink = forwardRef(function (props: Props, ref: Ref<HTMLElement>) {
    const { inheritParams, ...linkProps } = props;
    const mounted = useSyncExternalStore(
        () => () => {},
        () => true,
        () => false,
    );
    const href = useInheritParams(props.href || '#', URL_INHERIT_PARAMS);
    const isPlayer = /smart\.link/gi.test(props.href || '');
    const extraProps = {
        ...(isPlayer && { is: 'sxm-player-link' }),
    };
    const resolvedHref = inheritParams && mounted ? href : props.href;

    const newProps = isPlayer
        ? { ...props, target: '_blank' }
        : inheritParams
          ? { ...linkProps, href: resolvedHref }
          : linkProps;

    if (!inheritParams) {
        return <Link {...linkProps} ref={ref as Ref<HTMLAnchorElement>} />;
    }

    return <Link {...newProps} {...extraProps} ref={ref as Ref<HTMLAnchorElement>} />;
});

SXMLink.displayName = 'SXMLink';
export default SXMLink;
